import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { generatePath, useLocation, useParams } from "react-router-dom";
import { selectUserData } from "../../redux/auth/index.slice";
import { getCompletePathList } from "../../routes";
import { modalNotification } from "../../utils";

import authDriver from "../../utils/auth.util";
// import { AuthDriver as authDriver, modalNotification } from "../../utils";
// import { selectUserData } from "../../redux/AuthSlice/index.slice";
// import routesMap from "../../routeControl/adminRoutes";

function AppLayout({ setRedirectPath, children }) {
  const location = useLocation();
  const params = useParams();
  const userData = useSelector(selectUserData);

  function getGeneratedPath(data) {
    try {
      return generatePath(data, params);
    } catch (error) {
      return data;
    }
  }

  const activeRoute = getCompletePathList().find((e) => {
    const routePath = getGeneratedPath(e.key);
    const browserPath = location.pathname;
    return routePath === browserPath;
  });

  // const activeRoute = getCompletePathList().find(e => e.key === location.pathname);
  // const activeRoute = getCompletePathList().find(e => e.key.search(location.pathname.replace(/[0-9]/g, '')) >=0)
  const isPrivate = activeRoute?.private;
  const isValid = authDriver(activeRoute, userData, location.pathname);

  function checkValid() {
    if (!isValid) {
      let publicPath = "/";
      let privatePath = "";
      let path = "";
      if (location.pathname.search("admin") >= 0) {
        path = "admin";
      } else {
        path = "user";
      }

      const Role = userData?.role === "superadmin" ? "admin" : "user";

      let checkData = Role ?? path;

      if (checkData === "admin") {
        privatePath = "/admin/home";
      } else {
        privatePath = "/home";
        publicPath = "/";
      }
      if (isPrivate === true) {
        /** ******* If route type is private but not*****************
         * ******* able to prove their identity as valid entity*****
         * ********* so redirect it to public route******** */
        modalNotification({
          type: "warning",
          message: "Your Session is expired. Please login again.",
        });
        setRedirectPath(publicPath);
        // return false;
      } else if (isPrivate === false) {
        /** ******* If route type is public but not*****************
         * ******* able to prove their identity as valid entity*****
         * ********* so redirect it to private route******** */
        setRedirectPath(privatePath);
      }
    } else {
      // setRedirectPath(location.pathname);
    }
  }

  useEffect(() => {
    if (location?.pathname) checkValid();
  }, [location?.pathname]);

  return <>{isValid && children}</>;
}

export default AppLayout;
